import AuthService from './auth';
import { basic, admin } from './auth/impl';
import { STATUS } from './types';
import LoginService from './login';

const getter = () => {
  const user = localStorage.getItem('user');
  if (user) {
    return JSON.parse(user);
  }
  const userMsg = localStorage.getItem('userMsg');
  if (userMsg) {
    const temp = JSON.parse(userMsg);
    return {
      id: temp.USER_ID,
      userName: temp.USER_NAME,
      userPhone: temp.USER_PHONE,
      orgId: temp.ORG_ID,
      orgName: temp.ORG_NAME,
    };
  }
  return {};
};

const getToken = () => {
  return localStorage.getItem('token') || null;
}

export type {
  LoginService,
  AuthService,
  STATUS,
};

export default {
  STATUS,
  ...STATUS,
  AuthService,
  LoginService,
  getter,
  getToken,
  impl: {
    basic,
    admin,
  }
};
